import { Button, SpaceBetween } from "@amzn/awsui-components-react";
import React from "react";
import { OrderSubLineItem } from "@amzn/ito-client";
import { getString } from "common";

interface TableActionsProps {
  item: OrderSubLineItem;
  isEditing: boolean;
  hasChanges: boolean;
  savingRowId?: string;
  savingRowIds?: Set<string>;
  onEdit?: (item: OrderSubLineItem) => void;
  onCancel?: () => void;
  onSave?: () => void;
  mode?: "byRow" | "saveOnly";
  testIdPart?: string;
  buttonText?: "saveButton" | "addButton";
}

const TableActions: React.FC<TableActionsProps> = ({
  item,
  isEditing,
  hasChanges,
  savingRowId,
  savingRowIds,
  onEdit = () => { },
  onCancel = () => { },
  onSave = () => { },
  mode = "byRow",
  testIdPart = "comp",
  buttonText = "saveButton",
}) => {
  const isCurrentRowSaving = savingRowIds ? savingRowIds.has(item.id || "") : savingRowId === item.id;
  if (mode === "saveOnly") {
    return (
      <Button
        data-cy={`save-edit-${testIdPart}-button`}
        data-testid={`save-edit-${testIdPart}-button`}
        variant="primary"
        onClick={onSave}
        loading={isCurrentRowSaving}
        disabled={!hasChanges}
        aria-busy={isCurrentRowSaving ? "true" : undefined}
      >
        {getString(`orderDetails.tabs.itemsRequested.table.${buttonText}`)}
      </Button>
    );
  }

  if (isEditing) {
    return (
      <SpaceBetween direction="horizontal" size="xs">
        <Button
          data-cy={`save-edit-${testIdPart}-button`}
          data-testid={`save-edit-${testIdPart}-button`}
          variant="primary"
          onClick={onSave}
          loading={isCurrentRowSaving}
          disabled={!hasChanges}
          aria-busy={isCurrentRowSaving ? "true" : undefined}
        >
          {getString("orderDetails.tabs.itemsRequested.table.saveButton")}
        </Button>
        <Button
          data-cy={`cancel-edit-${testIdPart}-button`}
          data-testid={`cancel-edit-${testIdPart}-button`}
          variant="normal"
          onClick={onCancel}
          disabled={isCurrentRowSaving}
        >
          {getString("orderDetails.tabs.itemsRequested.table.cancelButton")}
        </Button>
      </SpaceBetween>
    );
  }

  return (
    <Button
      data-cy={`edit-row-${testIdPart}-button`}
      data-testid={`edit-row-${testIdPart}-button`}
      variant="normal"
      onClick={() => onEdit(item)}
    >
      {getString("orderDetails.tabs.itemsRequested.table.editButton")}
    </Button>
  );
};

export default TableActions;
